import * as ActionTypes from './actionType';
import WEB_API from '../../../API/api'

/**
 * 获得题目列表
 * **/
export const setQuestionList = (data) => ({
    type: ActionTypes.setQuestionList,
    payload: { data }
});

export const setShopcar = (data) => ({
    type: ActionTypes.setShopcar,
    payload: { data }
});
export const setQuestionListShopcar = (data) => ({
    type: ActionTypes.setQuestionListShopcar,
    payload: { data }
});

//把左侧树的数据放到redux里 在购物车页面使用
export const setTypeList = (data) => ({
    type: ActionTypes.setTypeList,
    payload: { data }
});
export const setAssistList = (data) => ({
    type: ActionTypes.setAssistList,
    payload: { data }
});
export const setTreeList = (data,product) => ({
    type: ActionTypes.setTreeList,
    payload: { data ,product}
});

export const setExpandedKeys = (data) => ({
    type: ActionTypes.setExpandedKeys,
    payload: { data }
});

export const setDefaultAssistList = (data) => ({
    type: ActionTypes.setDefaultAssistList,
    payload: { data }
});

export const setSelectedKeys = (data) => ({
    type: ActionTypes.setSelectedKeys,
    payload: { data }
});




// WEBPACK FOOTER //
// ./src/entry_app/question_manage/look_over_question/action.js